export const LIST_QUEUE_REQUEST = 'LIST_QUEUE_REQUEST'
export const LIST_QUEUE_SUCCESS = 'LIST_QUEUE_SUCCESS'
export const LIST_QUEUE_FAIL = 'LIST_QUEUE_FAIL'

export const CREATE_QUEUE_REQUEST = 'CREATE_QUEUE_REQUEST'
export const CREATE_QUEUE_SUCCESS = 'CREATE_QUEUE_SUCCESS'
export const CREATE_QUEUE_FAIL = 'CREATE_QUEUE_FAIL'

export const DELETE_QUEUE_REQUEST = 'DELETE_QUEUE_REQUEST'
export const DELETE_QUEUE_SUCCESS = 'DELETE_QUEUE_SUCCESS'
export const DELETE_QUEUE_FAIL = 'DELETE_QUEUE_FAIL'

export const DETAIL_QUEUE_REQUEST = 'DETAIL_QUEUE_REQUEST'
export const DETAIL_QUEUE_SUCCESS = 'DETAIL_QUEUE_SUCCESS'
export const DETAIL_QUEUE_FAIL = 'DETAIL_QUEUE_FAIL'

export const UPDATE_QUEUE_REQUEST = 'UPDATE_QUEUE_REQUEST'
export const UPDATE_QUEUE_SUCCESS = 'UPDATE_QUEUE_SUCCESS'
export const UPDATE_QUEUE_FAIL = 'UPDATE_QUEUE_FAIL'